import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "vue-drag-uploader__wrapper" };
const _hoisted_2 = { class: "add-button__body" };
const _hoisted_3 = { class: "add-button__text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_vue_drag_uploader_item = _resolveComponent("vue-drag-uploader-item");
    const _component_draggable = _resolveComponent("draggable");
    return (_openBlock(), _createElementBlock("div", {
        ref: "el",
        class: _normalizeClass(["vue-drag-uploader", { 'vue-drag-uploader--readonly': _ctx.isReadonly }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_draggable, _mergeProps({
                modelValue: _ctx.items,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.items) = $event)),
                class: "vue-drag-uploader__draggable-wrapper"
            }, { draggable: '.preview-img', animation: 300 }, {
                disabled: _ctx.isReadonly,
                onSort: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('reorder', $event))),
                "item-key": "key"
            }), {
                item: _withCtx(({ element: item, index }) => [
                    (_openBlock(), _createBlock(_component_vue_drag_uploader_item, {
                        item: item,
                        i: index,
                        "init-state": item.uploadState,
                        key: item.key,
                        ref: item.key,
                        "upload-url": _ctx.url,
                        size: _ctx.thumbSize,
                        "is-readonly": _ctx.isReadonly,
                        "queue-name": _ctx.id,
                        "max-concurrent": _ctx.maxConcurrent,
                        onDelete: _ctx.deleteItem,
                        onUploadStart: _ctx.uploadStart,
                        onUploadEnd: _ctx.uploadEnd,
                        onUploadProgress: _ctx.uploadProgress,
                        onItemClick: _ctx.itemClick,
                        style: { "animation-duration": ".3s" }
                    }, {
                        extra: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "extra", {
                                item: item,
                                i: index,
                                url: _ctx.url,
                                maxFiles: _ctx.maxFiles,
                                thumbSize: _ctx.thumbSize,
                                filesLimited: _ctx.maxFiles
                            })
                        ]),
                        _: 2
                    }, 1032, ["item", "i", "init-state", "upload-url", "size", "is-readonly", "queue-name", "max-concurrent", "onDelete", "onUploadStart", "onUploadEnd", "onUploadProgress", "onItemClick"]))
                ]),
                footer: _withCtx(() => [
                    (_ctx.canUpload)
                        ? (_openBlock(), _createElementBlock("div", {
                            class: "vue-drag-uploader__item add-button",
                            key: 'empty',
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.clickAdd())),
                            style: _normalizeStyle({ width: _ctx.thumbSize ? _ctx.thumbSize + 'px' : null, height: _ctx.thumbSize ? _ctx.thumbSize + 'px' : null })
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "add-button__icon" }, [
                                    _createElementVNode("span", { class: "fa fa-upload fa-2x" })
                                ], -1)),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.placeholder), 1)
                            ])
                        ], 4))
                        : _createCommentVNode("", true)
                ]),
                _: 3
            }, 16, ["modelValue", "disabled"])
        ])
    ], 2));
}
